import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "../Axios";
import { useCookies } from "react-cookie";
import Footer from "../Footer/Footer";
import "./Answerquestion.css";
import Header from "../Header/Header";
import { GuardSpinner } from "react-spinners-kit";

const Answerquestion = () => {
    const { id } = useParams();
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const uname = cookies.username;
    const [question, setQuestion] = useState([]);
    const [answer, setAnswer] = useState("");
    const [allanswers, setAllanswers] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const getQuestion = async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(`getquestion/${id}`);
                setQuestion(data.singleQuestion);
                const questionTimeout = setTimeout(() => setLoading(false), 100);
                return () => {
                    clearTimeout(questionTimeout);
                };
            } catch (error) {
                console.log(error.message);
            }
        };
        getQuestion();
    }, [id]);

    useEffect(() => {
        getAnswers();
    }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!answer) return;
        try {
            await axios.post("/answer", { answer, uname, id });
            setAnswer("");
            getAnswers();
        } catch (error) {
            console.log(error);
        }
    };

    const getAnswers = async () => {
        try {
            const { data } = await axios.get(`/allAnswers/${id}`);
            setAllanswers(data.allanswers);
        } catch (err) {
            console.log(err.message);
        }
    };

    return (
        <>
            {isLoading ? (
                <div className="loadingIcon">
                    <GuardSpinner frontColor={"#fe8402"} backColor={"#00ff89"} loading={isLoading} size={60} />
                </div>
            ) : (
                <>
                    <Header />
                    <div className="mt-5 answer">
                        <div className="container">
                            <h4>Question</h4>
                            {question?.map((el, index) => (
                                <div key={index}>
                                    <h5>{el.question}</h5>
                                    <p>{el.question_description}</p>
                                </div>
                            ))}
                            <div style={{ borderTop: "solid 1px gray", borderBottom: "solid 1px gray" }} className="py-2">
                                <h4>Answer from the Community</h4>
                            </div>
                            {allanswers?.map((el, index) => (
                                <div key={index} style={{ borderBottom: "1px solid #808080" }}>
                                    <div className="d-inline-flex">
                                        <i className="fa-solid fa-circle-user pe-2 pt-1" style={{ zoom: "500%" }}></i>
                                        <p className="pt-5">{el.answer}</p>
                                    </div>
                                    <div style={{ width: "80px", paddingTop: "10px" }}>
                                        <p style={{ textAlign: "center" }}>{el.user_name}</p>
                                    </div>
                                </div>
                            ))}

                            <div style={{ border: "solid 2px transparent", borderRadius: "5px", boxShadow: "3px 3px 4px 4px #EDEADE" }} className="py-5 my-5">
                                <form onSubmit={onSubmit}>
                                    <h4 className="text-center py-3">Answer the top question</h4>
                                    <Link to="/">
                                        <h6 className="text-center" style={{ color: "#fe8402" }}>
                                            Go to question page
                                        </h6>
                                    </Link>

                                    <div className="text-center">
                                        <textarea placeholder="Your answer..." value={answer} style={{ width: "80%", height: "150px" }} name="qAnswer" onChange={(t) => setAnswer(t.target.value)}></textarea>
                                    </div>
                                    <div>
                                        <button className="answerButton" style={{ marginLeft: "110px", backgroundColor: "#516cf0" }}>
                                            Post Your answer
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </>
    );
};

export default Answerquestion;
